export default "__VITE_PUBLIC_ASSET__20270ca8__"